import {useCallback, useMemo} from "react";
import {GoogleMap, useJsApiLoader, MarkerF} from "@react-google-maps/api";

const Map = (props) => {
    const containerStyle = {
        width: "100%",
        height: "400px",
        borderRadius: "15px",
    };

    const center = useMemo(() => {
        return {
            lat: parseFloat(props?.lat),
            lng: parseFloat(props?.lng),
        };
        // eslint-disable-next-line
    }, []);

    const {isLoaded} = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
    });

    const onLoad = useCallback(
        (map) => {
            if (window.google) {
                const bounds = new window.google.maps.LatLngBounds(center);
                map.fitBounds(bounds);
            }
        },
        [center]
    );

    const onUnmount = useCallback(function callback(map) {}, []);

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            <MarkerF position={center} />
        </GoogleMap>
    ) : (
        <></>
    );
};

export default Map;
